var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.75 0.494002C12.75 0.199268 12.4959 -0.0323143 12.2038 0.00767768C5.81072 0.883258 0.885498 6.36652 0.885498 13.0001C0.885498 20.243 6.75702 26.1146 13.9999 26.1146C17.9227 26.1146 21.4432 24.3922 23.8466 21.6624C24.0416 21.441 23.9886 21.101 23.7424 20.9382L15.105 15.2289C13.6346 14.257 12.75 12.6119 12.75 10.8493V0.494002ZM25.1234 18.8543C25.3694 19.0168 25.7026 18.9328 25.8302 18.667C26.6532 16.9517 27.1144 15.0298 27.1144 13.0001C27.1144 6.36658 22.1892 0.883364 15.7962 0.00770367C15.5041 -0.0322943 15.25 0.199288 15.25 0.494026V10.8493C15.25 11.7726 15.7133 12.6342 16.4836 13.1434L25.1234 18.8543Z",
    fill: "url(#paint0_linear_3_194)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_194",
    x1: 5.40031,
    y1: 15.7718,
    x2: 26.9496,
    y2: 16.1094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3965FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.338542,
    stopColor: "#0071F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.682292,
    stopColor: "#0096F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B8E6F9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpIt);
export default __webpack_public_path__ + "static/media/exp-it.c06eff2ee09141e31409f07e628ace94.svg";
export { ForwardRef as ReactComponent };